import { createSelector } from 'reselect'

export const getLabel = (state, props) => {
  return state['view-board'].labels.labelsById[props.id]
}

export default () => createSelector(
  [
    getLabel
  ],
  (
    label
  ) => ({
    id: label.id,
    name: label.name,
    color: label.color
  })
)
